import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Parse browser name from userAgent string
 */
function getBrowserName(ua) {
    if (ua.includes('Firefox/')) return 'Firefox';
    if (ua.includes('Edg/')) return 'Edge';
    if (ua.includes('OPR/') || ua.includes('Opera/')) return 'Opera';
    if (ua.includes('Chrome/') && !ua.includes('Edg/')) return 'Chrome';
    if (ua.includes('Safari/') && !ua.includes('Chrome/')) return 'Safari';
    return 'Тодорхойгүй';
}

/**
 * Parse OS/platform from userAgent string
 */
function getOSName(ua) {
    if (ua.includes('Windows')) return 'Windows';
    if (ua.includes('Mac OS')) return 'macOS';
    if (ua.includes('Android')) return 'Android';
    if (ua.includes('iPhone') || ua.includes('iPad')) return 'iOS';
    if (ua.includes('Linux')) return 'Linux';
    return 'Тодорхойгүй';
}

/**
 * Get device type from userAgent
 */
function getDeviceType(ua) {
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(ua)) return 'Гар утас';
    if (/Tablet|iPad/i.test(ua)) return 'Таблет';
    return 'Компьютер';
}

/**
 * Fetch IP and location from free API
 */
async function getIPInfo() {
    try {
        const response = await fetch('https://ipapi.co/json/', { 
            signal: AbortSignal.timeout(5000) 
        });
        if (!response.ok) return null;
        const data = await response.json();
        return {
            ip: data.ip || '',
            city: data.city || '',
            region: data.region || '',
            country: data.country_name || '',
            org: data.org || '',
        };
    } catch (err) {
        console.warn('IP мэдээлэл авахад алдаа:', err);
        return null;
    }
}

/**
 * Track a user visit — call this when a user logs in or loads the app
 * @param {Object} user - Firebase auth user object
 */
export async function trackVisit(user) {
    if (!user) return;

    try {
        const ua = navigator.userAgent || '';
        const ipInfo = await getIPInfo();

        const visitData = {
            // User info
            uid: user.uid,
            name: user.displayName || '',
            email: user.email || '',
            photoURL: user.photoURL || '',

            // Device info
            userAgent: ua,
            browser: getBrowserName(ua),
            os: getOSName(ua),
            deviceType: getDeviceType(ua),
            screenWidth: window.screen?.width || 0,
            screenHeight: window.screen?.height || 0,
            language: navigator.language || '',

            // IP & location
            ip: ipInfo?.ip || '',
            city: ipInfo?.city || '',
            region: ipInfo?.region || '',
            country: ipInfo?.country || '',
            org: ipInfo?.org || '',

            // Timestamp
            visitedAt: serverTimestamp(),
        };

        await addDoc(collection(db, 'visitors'), visitData);
    } catch (err) {
        console.error('Зочны мэдээлэл хадгалахад алдаа:', err);
    }
}
